import React, { FC, ReactNode } from "react";
import classNames from "classnames";

type Props = {
  children?: ReactNode;
  sidebar?: ReactNode;
  contentClassName?: string;
};

const InvoiceLayout: FC<Props> = ({ children, sidebar, contentClassName }) => {
  return (
    <div className="w-screen flex bg-purple-50 md:h-screen justify-between">
      <div
        className={classNames(
          "basis-full px-2 md:px-16 overflow-y-auto flex justify-center"
        )}
      >
        <div
          className={classNames(
            "max-w-[990px] py-8 min-h-fit",
            contentClassName
          )}
        >
          {children}
        </div>
      </div>

      <div className="hidden md:flex flex-none max-w-[324px] basis-[324px] bg-white p-8 flex flex-col relative">
        {sidebar}
      </div>
    </div>
  );
};

export default InvoiceLayout;
